/* istanbul ignore file */
import React from 'react';
import { UpdateForm, UpdateFormProps } from 'framework/form';
import useNoteService from 'domain/sales/shared/timeline/note/crmNoteService';
import { UpdateTimelineItemLayout } from 'framework/ui/timeline';
import NoteForm from 'domain/sales/shared/timeline/note/form/NoteForm';
import { ENTITY_DOCUMENT_TYPE } from 'domain/sales/opportunity/shared/constants';
import { useCompositeDocumentStorageContext, useCompositeDocumentStorageService } from 'domain/shared/documentStorage';

interface UpdateNoteFormProps extends Omit<UpdateFormProps, 'submitFormFunc'> {
  service: () => any;
  onCancel: () => void;
}

const UpdateNoteForm = ({ getDataFunc, onCancel, ...props }: UpdateNoteFormProps) => {
  const { getValidationSchema, update } = useNoteService();

  const { isDocumentStorageAvailable } = useCompositeDocumentStorageContext();
  const { commitDocument } = useCompositeDocumentStorageService(isDocumentStorageAvailable);

  return (
    <UpdateForm
      getDataFunc={getDataFunc}
      submitFormFunc={async (id, values) => {
        const artifactPath = values?.artifactPaths;
        const commitData = await commitDocument(artifactPath, ENTITY_DOCUMENT_TYPE.TIMELINE_NOTE_DOCUMENT);
        return update(id, { ...values, artifactPaths: commitData });
      }}
      getValidationSchemaFunc={getValidationSchema}
      {...props}
    >
      <UpdateTimelineItemLayout onCancel={onCancel}>
        <NoteForm />
      </UpdateTimelineItemLayout>
    </UpdateForm>
  );
};

export default UpdateNoteForm;
